/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupsflagnoavatar3Inputs */

const en_signupsflagnoavatar3 = /** @type {(inputs: Signupsflagnoavatar3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No photo`)
};

const de_signupsflagnoavatar3 = /** @type {(inputs: Signupsflagnoavatar3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Foto`)
};

/**
* | output |
* | --- |
* | "No photo" |
*
* @param {Signupsflagnoavatar3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsflagnoavatar3 = /** @type {((inputs?: Signupsflagnoavatar3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsflagnoavatar3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsflagnoavatar3(inputs)
	return de_signupsflagnoavatar3(inputs)
});
export { signupsflagnoavatar3 as "signupsFlagNoAvatar" }